import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'antd';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { CalendarDays } from 'lucide-react';

function PreOrder({
  platform,
  preOrderStatus,
}: {
  platform?: General.PlatformUpperCaseTunnel;
  preOrderStatus: Conversation.Product['preOrderStatus'];
}) {
  const { t } = useTranslate();

  return preOrderStatus === 'ALL_PRE_ORDER' ? (
    <Tooltip
      title={t(isTiKTokUpperCase(platform) ? '全部SKU预购' : 'domain.product.type.preOrder')}
    >
      <Icon
        style={{
          color: '#00BF69',
          background: '#CBF2E1',
        }}
      />
    </Tooltip>
  ) : preOrderStatus === 'PARTIAL_PRE_ORDER' ? (
    <Tooltip title={t('部分SKU预购')}>
      <Icon
        style={{
          color: '#336FFF',
          background: '#D6E8FF',
        }}
      />
    </Tooltip>
  ) : (
    <></>
  );
}

const Icon = styled(CalendarDays)`
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-right: 2px;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
`;

export default PreOrder;
